import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useFetch } from '../../hook/useFecth';
import useErrors from '../../hook/useErrors';
import server from '../../services/server';
import Select from 'react-select';
import useDialog from '../../hook/useDialog';
import { useConfirm } from '../../context/BootstrapConfirm';
import { Modal } from 'react-bootstrap';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { PriceInputMasked } from '../masks/PriceInputMasked';
// import { paymentMethod } from '../../helper/PaymentType';
// import TableListCreditsInOrder from '../TableListCreditsInOrder';

import { useState } from 'react';
import { pagamentoTipo } from '../../helper/helpers';



function PedidoContratoModal({ data, mutate }) {
    const { setErrors, toast } = useErrors();
    const { open: show, handleClose } = useDialog('contrato');
    const confirm = useConfirm();
    const [selectedCredit, setSelectedCredit] = useState(null);
    const contrato = data?.contratos?.find(i => i)

    // const { data: credits, mutate: mutateCredits } = useFetch(`orders/${data?.id}/credits`);


    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, handleBlur, touched, values, setValues, setFieldValue, resetForm } =
        useFormik({
            initialValues: {
                action: 'create',
                id: '',
                valorTotal: '',
                tipo: '',
                parcela: '',
            },
            // validationSchema: Yup.object().shape({
            //     product_id: Yup.string().required('Informe o produto'),
            // }),
            validateOnMount: true,
            validateOnChange: true,
            onSubmit: async (values, { setSubmitting, resetForm }) => {
                try {
                    setSubmitting(true);
                    if (values.action === 'update') {
                        await server.post(`pedido/${data?.id}/pagamento`, values);
                        toast.success('Item adicionado com sucesso.');
                    };
                    if (values.action === 'pagamento') {
                        await server.patch(`pedido/${data?.id}/pagamento`, { ...values, ...selectedCredit });
                        // await mutateCredits();
                        setFieldValue({ method: '' });
                        setSelectedCredit(null);
                        toast.success('Pagamento adicionado com sucesso.');
                    };
                    if (values.action === 'closeOrder') {
                        await server.patch(`orders/${data?.id}`);
                        handleClose()
                    };
                    await mutate();
                    resetForm();
                    // handleClose();
                    setSubmitting(false);
                    // resetForm();
                } catch (error) {
                    setSubmitting(false);
                    setErrors(error);
                };
            },
        });

    const remainingValue = ((data?.valorTotal - data?.totalRecebido).toFixed(2)) || 0.0;
    useEffect(() => {
        if (Boolean(data)) {
            setValues(
                {
                    ...values,
                    valorTotal: remainingValue || 0,
                    action: 'update',
                },
                true,
            );
        }
    }, [data]);

    function handlePaymentWithCredit() {
        setFieldValue('action', 'pagamento', true);
        handleSubmit();
    };

    function handlePayment() {
        setFieldValue('action', 'update', true);
        handleSubmit();
    };

    async function handleCloseOrder() {
        try {
            await confirm({ message: 'Tem certeza que deseja fechar o pedido sem pagamento ??' });
            setFieldValue('action', 'closeOrder', true);
            handleSubmit();
        } catch (e) { }
    };

    async function handleRemove() {
        try {
            await confirm({ message: 'Você tem certeza que está removendo?' });
            setFieldValue('action', 'delete');
            handleSubmit();
        } catch (e) { }
    }

    const statusContrato = {
        pending: "Aguardando assinatura",
        signed: "Contrato assinado",
        CONTRATO_ASSINADO: "Contrato assinado"
    };

    const contratoStatusAssinado =  ['CONTRATO_ASSINADO'].includes(contrato?.contratoStatus)
    

    const urlContrato = contratoStatusAssinado ? contrato?.contratoDados?.signed_file : contrato?.contratoDados?.signers?.find(i => i).sign_url

    const cartaoCreditoSelecionado = ['cartaoCredito'].includes(values?.tipo)

    console.log(contrato?.contratoStatus )

    return (
        <>
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-md"> Detalhes contrato </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-20 mt-10">
                        {/* Total Bruto */}
                        <div className=" col-xxl-5 col-xl-6 col-md-12 col-sm-12">
                            <div className="d-flex align-items-center gap-3 mb-3">
                                <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-info-50 d-flex justify-content-center align-items-center">
                                    <span className={`w-40-px h-40-px ${["signed", "CONTRATO_ASSINADO"].includes(contrato?.contratoStatus) ? "bg-success-main" : "bg-danger-main"}  text-white d-flex justify-content-center align-items-center radius-8`}>
                                        {["signed", "CONTRATO_ASSINADO"].includes(contrato?.contratoStatus) ?
                                            (<Icon icon="mdi:file-check-outline" width="24" height="24" />) :
                                            (<Icon icon="mdi:file-clock-outline" width="24" height="24" />)
                                        }





                                    </span>
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="text-md mb-0 fw-normal">Status:</h6>
                                    <span className="text-sm text-secondary-light fw-normal">
                                        {statusContrato[contrato?.contratoStatus]}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Total Recebido */}


                        {/* Total a Receber */}
                        {/* <div className="col-md-4">
                            <div className="d-flex align-items-center gap-3 mb-3">
                                <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-warning-50 d-flex justify-content-center align-items-center">
                                    <span className="w-40-px h-40-px bg-warning-main text-white d-flex justify-content-center align-items-center radius-8">
                                        <Icon icon="mdi:cash-clock" width="24" height="24" />
                                    </span>
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="text-md mb-0 fw-normal">Total a Receber:</h6>
                                    <span className="text-sm text-secondary-light fw-normal">
                                        {(data?.valorTotal - data?.totalRecebido)?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </span>
                                </div>
                            </div>
                        </div> */}
                      
                        {!contrato?.signed_file && (

                            <div className=" col-xxl-5 col-xl-6 col-md-12 col-sm-12">
                                <div className="d-flex align-items-center gap-3 mb-3">
                                    <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-success-50 d-flex justify-content-center align-items-center">
                                        <span className="w-40-px h-40-px bg-success-main text-white d-flex justify-content-center align-items-center radius-8">
                                            <Icon icon="mdi:file-link" width="24" height="24" />
                                        </span>
                                    </div>
                                    <div className="flex-grow-1">
                                        <h6 className="text-md mb-0 fw-normal">{contratoStatusAssinado ? 'Documento assinado' : 'Documento para assinatura'}:</h6>
                                        {urlContrato && (
                                            <a
                                                className="text-sm text-secondary-light fw-normal"
                                                href={urlContrato}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {contratoStatusAssinado ? 'Download do documento assinado' : 'Download do link para assinatura'}
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>

                        )}


                        {contrato?.signed_file && (
                           <div className=" col-xxl-5 col-xl-6 col-md-12 col-sm-12">
                                <div className="d-flex align-items-center gap-3 mb-3">
                                    <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-success-50 d-flex justify-content-center align-items-center">
                                        <span className="w-40-px h-40-px bg-success-main text-white d-flex justify-content-center align-items-center radius-8">
                                            <Icon icon="mdi:file-link" width="24" height="24" />
                                        </span>
                                    </div>
                                    <div className="flex-grow-1">
                                        <h6 className="text-md mb-0 fw-normal">Documento assinado:</h6>
                                        {contrato?.signed_file && (
                                            <a
                                                className="text-sm text-primary fw-bold"
                                                href={contrato?.signed_file}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'underline' }}
                                            >
                                                Baixar PDF
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>




                </Modal.Body>

                <Modal.Footer className="pt-4 px-0 border-top d-flex justify-content-between align-items-center">


                </Modal.Footer>
            </Modal>
        </>
    );
}

export default PedidoContratoModal;


